import { useQuery } from '@tanstack/react-query';
import { iqDataSourcesQueryOptions } from '@/entities/iq-data-source';

/**
 * Whether this workspace has activated any file-upload source. Drives whether the report
 * header offers the panel at all: a workspace with none would otherwise get a button that
 * opens an empty drawer.
 */
export const useHasActivatedDataSources = (): boolean => {
  const { data } = useQuery(iqDataSourcesQueryOptions());
  return (data ?? []).some((item) => item.enabled);
};
